import * as React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

import useTapPay from '../../hooks/useTapPay';
import { Context } from '../../context/DataContext';

const TapPayPage = () => {
  const { state, sendTapPayPrimeExt3D } = React.useContext(Context);
  const {
    customerInfo: { orderId },
    app: { ApIdExt: appId, ApKeyExt: appKey, Env: env },
    loginInfo: { tokenLogin, token },
  } = state;
  const [TapPay] = useTapPay({
    appId,
    appKey,
    env,
  });
  const [isValidated, setIsValidated] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [cardholderEName, setCardholderEName] = React.useState('');

  React.useEffect(() => {
    // Fix TapPay cardSetup issue: rendering iframe multiple times
    const tappayIframeBox = document.getElementById('tappay-iframe');
    if (tappayIframeBox) {
      while (tappayIframeBox.firstChild) {
        tappayIframeBox.removeChild(tappayIframeBox.firstChild);
      }
    }

    TapPay.cardSetup(
      '#tappay-iframe',
      {
        color: 'rgb(0,0,0)',
        fontSize: '15px',
        lineHeight: '24px',
        fontWeight: '300',
        errorColor: 'red',
        placeholderColor: '',
      },
      {
        isUsedCcv: true,
        // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
        isMaskCreditCardNumber: true,
        maskCreditCardNumberRange: {
          beginIndex: 6,
          endIndex: 11,
        },
      }
    );
    TapPay.onCardUpdate(({ canGetPrime }) => {
      setIsValidated(canGetPrime);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCardholderNameChange = (event) => {
    const value = event.target.value;
    // 只允許英文字母、空白、- . , 符號，並轉換為大寫
    const filteredValue = value
      .replace(/[^A-Za-z\s\-.,]/g, '')
      .slice(0, 45)
      .toUpperCase();
    setCardholderEName(filteredValue);
  };

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        信用卡付款
      </Typography>
      <Box>
        <Box sx={{ px: 2, pt: 2 }}>
          <Typography
            variant='h6'
            sx={{ my: 1, textAlign: 'left' }}>
            信用卡卡號
          </Typography>
          <Box
            id='tappay-iframe'
            sx={{
              margin: 0,
              outline: 0,
              tapHighlightColor: 'rgba(255,255,255,0)',
              lineHeight: '1.21428571em',
              padding: '.578571em 1em',
              fontSize: '1em',
              background: '#fff',
              border: '1px solid rgba(34,36,38,.15)',
              color: 'rgba(0,0,0,.87)',
              borderRadius: '.28571429rem',
              boxShadow: '0 0 0 0 transparent inset',
              transition: 'color .1s ease,border-color .1s ease',
              width: '100%',
              boxSizing: 'border-box',
            }}
          />
        </Box>
        <Box sx={{ px: 2, pb: 2 }}>
          <Typography
            variant='h6'
            sx={{ my: 1, textAlign: 'left' }}>
            持卡人英文名稱
          </Typography>
          <TextField
            fullWidth
            value={cardholderEName}
            onChange={handleCardholderNameChange}
            placeholder='請輸入持卡人英文名稱'
            inputProps={{ maxLength: 45 }}
            helperText={`請輸入信用卡上印製的英文姓名(輸入的字元僅支援英文字母;符號只接受空白或-, ．, ，)`}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '.28571429rem',
                backgroundColor: '#fff',
              },
              '& .MuiOutlinedInput-input': {
                padding: '0.578571em 1em',
                fontSize: '1em',
                lineHeight: '1.21428571em',
              },
            }}
          />
        </Box>
        <Typography
          variant='body1'
          sx={{ my: 2, textAlign: 'justify', px: 2 }}>
          本人同意於定期繳款截止日前，依上述交易進行自動扣款。且於下列卡號因補/換/續發新卡或升等其他事由而變更時，此授權對變更後之卡號亦適用之。
        </Typography>
        {errorMsg ? (
          <Box>
            <Typography
              variant='h6'
              sx={{ my: 2, color: 'red' }}>
              {errorMsg}
            </Typography>
          </Box>
        ) : null}
        <Button
          variant='contained'
          sx={{ width: 168 }}
          disabled={!isValidated || !cardholderEName.trim()}
          onClick={() => {
            // navigate('/extend-new/upload-photos');
            setErrorMsg('');
            TapPay.getDirectPayPrime()
              .then(({ prime }) => {
                // success
                const BASE_URL =
                  process.env.PUBLIC_URL === '/' ? '' : process.env.PUBLIC_URL;
                const RETURN_URL_PREFIX = `${window.location.origin}${BASE_URL}/extend-new/payment/${orderId}`;
                const RETURN_URL_POSTFIX = `?loginType=${tokenLogin ? 'token' : 'member'}${tokenLogin ? `&token=${token}` : ''
                  }`;
                // send prime to api
                sendTapPayPrimeExt3D(
                  {
                    orderId,
                    primeCode: prime,
                    cardholderEName: cardholderEName.trim(),
                    frontend_redirect_url: `${RETURN_URL_PREFIX}/validation${RETURN_URL_POSTFIX}`,
                    go_back_url: `${RETURN_URL_PREFIX}/fail${RETURN_URL_POSTFIX}`,
                  },
                  ({ responseCode, redirectURL, responseMsg }) => {
                    if (responseCode === '003') {
                      window.location.href = redirectURL;
                    } else {
                      setErrorMsg(responseMsg);
                    }
                  }
                );
              })
              .catch((e) => {
                // error
                setErrorMsg(e);
              });
          }}>
          下一步
        </Button>
      </Box>
    </Box>
  );
};

export default TapPayPage;
